const Identificacao = [
  {
    id: 1,
    name: 'nome',
    label: 'Nome Motorista',
    disabled: true,
    type: 'text',
  },
  {
    id: 2,
    name: 'cpfmotorista',
    label: 'CPF',
    disabled: true,
    type: 'text',
  },
  {
    id: 3,
    name: 'celular',
    label: 'Celular',
    type: 'text',
  },
  {
    id: 4,
    name: 'cnpj',
    label: 'CNPJ Transportadora',
    disabled: true,
    type: 'text',
  },
  {
    id: 5,
    name: 'transportadora',
    label: 'Nome Transportadora',
    disabled: true,
    type: 'text',
  },
  {
    id: 6,
    name: 'clienteDestino',
    label: 'Cliente/Destino',
    type: 'text',
  },
  {
    id: 7,
    name: 'tipoProduto',
    label: 'Tipo Produto',
    disabled: true,
    type: 'text',
  },
  {
    id: 8,
    name: 'validadeTpp',
    label: 'Validade Autorização Ambiental para TPP',
    type: 'date',
  },
  {
    id: 9,
    name: 'placacavalo',
    label: 'Placa Cavalo',
    disabled: true,
    type: 'text',
  },
  {
    id: 10,
    name: 'placasTanques',
    label: 'Placa(s) Tanque(s)',
    disabled: true,
    type: 'text',
  },
];

const Documentacao = [
  {
    id: 11,
    name: 'cnh',
    label: 'Nº Registro da CNH',
    type: 'text',
  },
  {
    id: 12,
    name: 'validadeCnh',
    label: 'Validade CNH',
    type: 'date',
  },
  {
    id: 13,
    name: 'categoriaCnh',
    label: 'Categoria CNH',
    type: 'text',
  },
  {
    id: 14,
    name: 'validadeMopp',
    label: 'Validade MOPP',
    type: 'date',
  },
  {
    id: 15,
    name: 'cvvtr',
    label: 'Valid. Cert. Veículo Tanque Rodoviário - Inmetro',
    type: 'date',
  },
  {
    id: 16,
    name: 'civCavalo',
    label: 'CIV (Inmetro) - Validade Cavalo',
    type: 'date',
  },
  {
    id: 17,
    name: 'civTanque',
    label: 'CIV (Inmetro) - Validade Tanque',
    type: 'date',
  },
  {
    id: 18,
    name: 'aet',
    label: 'O veículo possui AET – Autorização Especial de Trânsito',
    type: 'boolean',
  },
  {
    id: 19,
    name: 'dnit',
    label: 'Veículo possui DNIT',
    type: 'boolean',
  },
];

const Motorista = [
  {
    id: 20,
    name: 'trajes',
    label:
      'Trajado adequadamente (calça comprida, camisa e botina de segurança)?',
  },
  {
    id: 21,
    name: 'semSinaisCansaco',
    label: 'Sem sinais de cansaço, sono ou embriagues?',
  },
];

const Veiculo = [
  {
    id: 22,
    name: 'instalacoesEletricas',
    label:
      'Instalação elétrica (setas, lanternas, luz de freio, faróis em funcionamento e com fios isolados)?',
  },
  {
    id: 23,
    name: 'limpadores',
    label: 'Limpador de para-brisas funcionando?',
  },
  {
    id: 24,
    name: 'tanquesOk',
    label:
      'Tanque em bom estado (sem sinais de corrosão, amassado ou com vazamentos)?',
  },
  {
    id: 25,
    name: 'tacografo',
    label: 'Tacógrafo funcionando?',
  },
  {
    id: 26,
    name: 'pontoCaboAterramento',
    label: 'Possui ponto para cabo de aterramento?',
  },
  {
    id: 27,
    name: 'pneusOk',
    label: 'Pneus em bom estado (inclusive estepe)?',
  },
  {
    id: 28,
    name: 'faixasRefletivas',
    label:
      'Faixas refletivas nas laterais, na traseira da carroceria e nas extremidades do para-choque?',
  },
];

const Seguranca = [
  {
    id: 29,
    name: 'extintores',
    label:
      'Possui extintor de incêndio (mínimo 01 de pó químico de 8 kg ou 02 de CO₂ de 6kg)?',
  },
  {
    id: 30,
    name: 'calcosRodas',
    label: 'Possui calços para rodas?',
  },
  {
    id: 31,
    name: 'cordasFitasCorrentes',
    label: 'Possui cordas, fitas ou correntes de material plástico?',
  },
  {
    id: 32,
    name: 'placasSinalizacao',
    label: 'Possui placas de sinalização?',
  },
  {
    id: 33,
    name: 'cavaletesCones',
    label: 'Possui cavaletes/cones de sinalização?',
  },
  {
    id: 34,
    name: 'lanternas',
    label: 'Possui lanterna a prova de explosão?',
  },
  {
    id: 35,
    name: 'oculosSeguranca',
    label: 'Possui óculos de segurança, protetor fácil ou máscara?',
  },
  {
    id: 36,
    name: 'capaceteSeguranca',
    label: 'Possui capacete de segurança?',
  },
  {
    id: 37,
    name: 'luvasPvc',
    label: 'Possui luva de PVC forrada?',
  },
];

const Sinalizacao = [
  {
    id: 38,
    name: 'panelSeguranca',
    label:
      'Possui painel de segurança 40x30 cm na cor laranja com números 33 – 1170 em preto?',
  },
  {
    id: 39,
    name: 'rotuloRisco',
    label: `Possui rótulo de risco 30x30 cm na cor vermelha com símbolo de fogo e legenda (líquido inflamável) e número 3 em preto?`,
  },
];

const SinalizacaoItems = [
  {
    id: 38,
    name: 'panelSegurancaFrente',
    label: 'Frente',
  },
  {
    id: 38,
    name: 'panelSegurancaDireita',
    label: 'Lateral Direita',
  },
  {
    id: 38,
    name: 'panelSegurancaEsquerda',
    label: 'Lateral Esquerda',
  },
  {
    id: 38,
    name: 'panelSegurancaTraseira',
    label: 'Traseira',
  },
  {
    id: 39,
    name: 'rotuloRiscoFrente',
    label: 'Frente',
  },
  {
    id: 39,
    name: 'rotuloRiscoDireita',
    label: 'Lateral Direita',
  },
  {
    id: 39,
    name: 'rotuloRiscoEsquerda',
    label: 'Lateral Esquerda',
  },
  {
    id: 39,
    name: 'rotuloRiscoTraseira',
    label: 'Traseira',
  },
];

const Outros = [
  {
    id: 40,
    name: 'responsavel',
    label: 'Responsável pela Inspeção',
  },
  {
    id: 41,
    name: 'horarioInspecao',
    label: 'Horário da Inspeção',
  },
];

export const ChecklistDataEtanol = {
  Identificacao,
  Documentacao,
  Motorista,
  Veiculo,
  Seguranca,
  Sinalizacao,
  SinalizacaoItems,
  Outros,
};
